import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { FaCheck } from "react-icons/fa6";
import "./RegistroEnviado.css";

const RegistroEnviado = () => {
  return (
    <>
      <Navbar />

      <main className="registro-enviado column fixed">
        <div className="check align-center">
          <FaCheck />
        </div>
        <p className="text-center">
          Hemos recibido tus datos. Primero debes validar tu correo electrónico a través del enlace que te hemos enviado.
          <br />
          Una vez confirmado, revisaremos tu solicitud de registro y nos pondremos en contacto contigo.
        </p>

        <Link to="/" className="verde">
          Volver a la página Pasaporte Hacía el Empleo
        </Link>
      </main>
    </>
  );
};

export default RegistroEnviado;
